import amex from "../assets/AMEX.png";
import discover from "../assets/Discover.png";
import jcb from "../assets/JCB.png";
import mastercard from "../assets/Mastercard.png";
import visa from "../assets/Visa.png";

/**
 * Checks if a payment card is expired based on its expiry date
 * @param expiryDate - Card expiry date in MM/YYYY format
 * @returns true if the card is expired, false otherwise
 */
export const isCardExpired = (expiryDate: string): boolean => {
  const expiryDateArray = expiryDate.split("/");
  const expiryMonth = parseInt(expiryDateArray[0], 10);
  const expiryYear = parseInt(expiryDateArray[1], 10);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  if (expiryYear < currentYear) {
    return true;
  }
  if (expiryYear === currentYear && expiryMonth < currentMonth) {
    return true;
  }
  return false;
};

/**
 * Checks if a payment card brand has an icon available
 * @param brand - Card brand name (e.g., "visa", "mastercard")
 * @returns true if the brand has an icon, false otherwise
 */
export const doesCardHaveIcon = (brand: string): boolean => {
  return ["visa", "mastercard", "amex", "jcb", "discover"].includes(
    brand.toLowerCase()
  );
};

/**
 * Gets the icon path for a payment card brand
 * @param brand - Card brand name (e.g., "visa", "mastercard")
 * @returns Path to the brand icon image, or undefined if not found
 */
export const getPaymentIcon = (brand: string): string | undefined => {
  switch (brand.toLowerCase()) {
    case "visa":
      return visa;
    case "mastercard":
      return mastercard;
    case "jcb":
      return jcb;
    case "amex":
      return amex;
    case "discover":
      return discover;
  }
};
